import { OpenHotelTaskDirective } from "./open-hotel-task.directive";
import { OpenCarTaskDirective } from "./open-car-task.directive";
import { OpenAirTaskDirective } from "./open-air-task.directive";
import { OpenPnrDirective } from "./open-pnr.directive";

export * from "./open-hotel-task.directive";
export * from "./open-car-task.directive";
export * from "./open-air-task.directive";
export * from "./open-pnr.directive";

export const DIRECTIVES = [
  OpenHotelTaskDirective,
  OpenCarTaskDirective,
  OpenAirTaskDirective,
  OpenPnrDirective
]
